export default __webpack_public_path__ + "static/media/thumbnail.7969c47a.png";